import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private cdn: string;
  private version: string;
  private api: string;
  private httpOptions: any;

  constructor(private http: HttpClient) {
    this.api = environment.api_url;
    this.cdn = environment.cdn_url;
    this.version = environment.images_version;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
  }

  public getCompanyPicture(id): string {
    return `${this.cdn}/images/organizations/${this.version}/${id}.png`;
  }

  public getCompanyById(id): Observable<any> {
    return this.http.get(`${this.api}/topics/${id}`, this.httpOptions);
  }
}
